import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="about-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1
          className="text-4xl sm:text-5xl font-bold mb-8 text-center"
          style={{ fontFamily: 'Playfair Display, serif' }}
          data-testid="about-title"
        >
          About Nepora
        </h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-xl text-center mb-12">
            <span className="text-[#D4AF37] font-bold">NEPORA – Nepali Clothing, Jewelry & Everyday Essentials</span>
          </p>

          <div className="bg-gray-50 p-8 rounded-xl mb-12">
            <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Our Mission
            </h2>
            <p className="text-lg text-gray-700">
              At NEPORA, our mission is to bring Nepali culture, fashion, and affordability together — making it 
              easy for the Nepali community and everyone else to shop unique styles locally and online.
            </p>
          </div>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            More Than a Clothing Store
          </h2>
          <p className="text-gray-700 mb-6">
            NEPORA is more than a clothing store — we are a Nepali lifestyle destination. We bring 
            the vibrant colors, intricate designs, and timeless beauty of Nepal to the heart of Ohio, 
            offering authentic Nepali styles at prices everyone can afford.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            What We Sell
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white border border-gray-200 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 flex items-center">
                <span className="mr-2">👗</span> Clothing
              </h3>
              <ul className="text-gray-700 space-y-1 text-sm">
                <li>• Sarees (Butter Silk, Embroidered, Daily & Festival)</li>
                <li>• Traditional Nepali Dresses</li>
                <li>• Bakhu (Traditional Dress)</li>
                <li>• Tamang Lungi & Laliguras Lungi</li>
                <li>• Casual & Festive Wear</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 flex items-center">
                <span className="mr-2">💍</span> Nepali Jewelry
              </h3>
              <ul className="text-gray-700 space-y-1 text-sm">
                <li>• Traditional Nepali-style necklaces</li>
                <li>• Earrings, bangles, tikka, sets</li>
                <li>• Lightweight, affordable, everyday wear</li>
                <li>• Over 200+ jewelry SKUs</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 flex items-center">
                <span className="mr-2">💄</span> Beauty & Accessories
              </h3>
              <ul className="text-gray-700 space-y-1 text-sm">
                <li>• Face & beauty products</li>
                <li>• Hair accessories</li>
                <li>• Bangles, clips, bindis</li>
                <li>• Everyday fashion accessories</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 flex items-center">
                <span className="mr-2">💸</span> $1–$10 Deals
              </h3>
              <ul className="text-gray-700 space-y-1 text-sm">
                <li>• Jewelry & accessories</li>
                <li>• Beauty products</li>
                <li>• Gift items</li>
                <li>• Perfect for daily wear & impulse buys</li>
              </ul>
            </div>
          </div>

          <h2 className="text-2xl font-bold mt-12 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Why Shop Nepora?
          </h2>
          <div className="grid md:grid-cols-2 gap-4 mb-8">
            <div className="flex items-start">
              <span className="text-2xl mr-3">🇳🇵</span>
              <div>
                <h4 className="font-bold mb-1">Authentic Nepali Style</h4>
                <p className="text-sm text-gray-600">Handpicked designs inspired by Nepali culture</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <span className="text-2xl mr-3">🏬</span>
              <div>
                <h4 className="font-bold mb-1">Local Store, Real People</h4>
                <p className="text-sm text-gray-600">Shop online or pick up in Reynoldsburg</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <span className="text-2xl mr-3">💰</span>
              <div>
                <h4 className="font-bold mb-1">Affordable Pricing</h4>
                <p className="text-sm text-gray-600">Unique items you won't find on Amazon or Temu</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <span className="text-2xl mr-3">⚡</span>
              <div>
                <h4 className="font-bold mb-1">Fast Local Pickup</h4>
                <p className="text-sm text-gray-600">Buy today, pick up today</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <span className="text-2xl mr-3">🛍️</span>
              <div>
                <h4 className="font-bold mb-1">New Arrivals Weekly</h4>
                <p className="text-sm text-gray-600">Fresh styles added every week</p>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-bold mt-12 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Visit Us
          </h2>
          <div className="bg-[#D4AF37] bg-opacity-10 p-6 rounded-lg">
            <p className="text-gray-800 mb-2">
              <strong className="text-[#D4AF37]">📍 Address:</strong><br />
              6575 E Livingston Ave, Reynoldsburg, OH 43068
            </p>
            <p className="text-gray-800 mb-2">
              <strong className="text-[#D4AF37]">🕘 Store Hours:</strong><br />
              Open Daily 9:00 AM – 9:00 PM
            </p>
            <p className="text-gray-800 mb-2">
              <strong className="text-[#D4AF37]">🚗 Free Local Pickup Available</strong>
            </p>
            <p className="text-gray-800">
              <strong className="text-[#D4AF37]">📦 Free Shipping on Orders Over $75</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
